import { WarningLoadingState } from 'redux-state/weather-warnings/types.js';
import { HeaderLinkText } from './header-link-text.js';
import { IWarningsPanelData } from './warning-panel-data.js';

interface IProps {
  warningState?: IWarningsPanelData;
  hasDropdown: boolean;
}

/** If there is not dropdown add a link if there isnt dont */
const ContentWrapper = ({ children, hasDropdown }: { children: JSX.Element; hasDropdown: boolean }): JSX.Element => {
  if (hasDropdown) {
    return children;
  }
  return (
    <span
      style={{ minHeight: '19px' }}
      className="u-flex u-flexAlignItemsCenter fake-link fake-link--opacity u-textBold"
    >
      {children}
    </span>
  );
};

export const WarningsHeaderLink = ({ hasDropdown, warningState }: IProps) => {
  if (warningState?.type === WarningLoadingState.loaded) {
    const className = hasDropdown && warningState.hasWarnings ? 'dropdown-chevron' : '';

    // Need to set height in link to align with weather warnings links with icon set at 24px
    return (
      <div data-module="warnings-hl" className={`WeatherWarning-bar-warning-item u-flexAlignSelfStart ${className}`}>
        <ContentWrapper hasDropdown={hasDropdown}>
          <HeaderLinkText warningState={warningState} />
        </ContentWrapper>
      </div>
    );
  }
  // not yet loaded
  return null;
};
